import script from "./AccidentCompleted.vue?vue&type=script&setup=true&lang=js"
export * from "./AccidentCompleted.vue?vue&type=script&setup=true&lang=js"

import "./AccidentCompleted.vue?vue&type=style&index=0&id=f55ad6be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f55ad6be"]])

export default __exports__